import { Fragment, useState } from "react";
import { HomeTab, tabValues } from "components/home/HomeTab";
import { TrendingFeed } from "components/home/TrendingFeed";
import { PersonalFeed } from "components/home/PersonalFeed";
import { LoginSplash } from "components/home/LoginSplash";
import "./HomeFeed.scss";

interface IProps {
  tab: tabValues;
  isUserLoggedIn: boolean;
}

export const HomeFeed = ({ tab, isUserLoggedIn }: IProps) => {
  const [currentTab, setCurrentTab] = useState<string>(tab);

  const changeTab = (value: string): void => {
    setCurrentTab(value);
  };

  return (
    <Fragment>
      <HomeTab tab={currentTab} onChange={changeTab}/>

      <div className="homeFeed">
        {currentTab === tabValues.TRENDING && <TrendingFeed />}
        {currentTab === tabValues.FOR_YOU && isUserLoggedIn && <PersonalFeed />}
        {currentTab === tabValues.FOR_YOU && !isUserLoggedIn && <LoginSplash />}
      </div>
    </Fragment>
  );
};
